import { createRequestTypes } from '../utils';

export const SAVE_DOCUMENT = createRequestTypes('document/SAVE_DOCUMENT');
export const DOWNLOAD_DOCUMENT = createRequestTypes('document/DOWNLOAD_DOCUMENT');
export const GET_IMAGE_DOCUMENT = createRequestTypes('document/GET_IMAGE_DOCUMENT');
